import docCookies from 'doc-cookies';

const BASE_URL_SANCTUM = '/sanctum/csrf-cookie/';

export default () => ({
  queryParams: {},

  init() {
    this.queryParams = this.getAllQueryParams();

    if (this.queryParams.utm_campaign) {
      this.storeCookies().catch(error => {
        console.error('Store cookies error:', error);
      });
    }
  },

  async getXsfrToken() {
    const response = await fetch(BASE_URL_SANCTUM);
    if (!response.ok) {
      throw new Error(`Error fetching XSRF token! status: ${response.status}`);
    }
    // Assuming the XSRF-TOKEN is set as a cookie by the response of this request
  },

  async storeCookies() {
    await this.getXsfrToken();

    const data = JSON.stringify(this.queryParams);

    try {
      const response = await fetch('/store-cookies', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
          'X-XSRF-TOKEN': docCookies.getItem('XSRF-TOKEN'),
        },
        body: data,
      });

      if (!response.ok) {
        throw new Error(`Error! status: ${response.status}`);
      }
    } catch (error) {
      console.error('Error:', error);
      throw error; // Propagate error for further handling if needed
    }
  },

  getAllQueryParams() {
    const queryParams = new URLSearchParams(window.location.search);
    const params = {};
    queryParams.forEach((value, key) => {
      params[key] = value;
    });
    return params;
  }
});
